import { type Element } from "html-react-parser";

import { TooltipInfoIcon } from "@vega-core/components/Tooltip/TooltipInfoIcon";

export const DYNAMIC_TOOLTIP_ATTRIBUTE = "data-tooltip";

type Props = {
  domNode: Element;
};

export function DynamicTooltip({ domNode }: Props) {
  return (
    <TooltipInfoIcon
      className="ml-1 inline-block align-middle"
      content={domNode.attribs[DYNAMIC_TOOLTIP_ATTRIBUTE]}
    />
  );
}
